import { Routes, Route } from 'react-router-dom';
import { MarketingLayout } from './layouts/MarketingLayout';
import { AppShellLayout } from './layouts/AppShellLayout';
import { HomePage } from './pages/HomePage';
import { ProductOverviewPage } from './pages/product/ProductOverviewPage';
import { CoreHRPage } from './pages/product/CoreHRPage';
import { OnboardingPage } from './pages/product/OnboardingPage';
import { AttendanceLeavePage } from './pages/product/AttendanceLeavePage';
import { PayrollPage } from './pages/product/PayrollPage';
import { PerformancePage } from './pages/product/PerformancePage';
import { TalentManagementPage } from './pages/product/TalentManagementPage';
import { RecruitmentPage } from './pages/product/RecruitmentPage';
import { LearningPage } from './pages/product/LearningPage';
import { ESSPage } from './pages/product/ESSPage';
import { AIAssistantPage } from './pages/product/AIAssistantPage';
import { AnalyticsPage } from './pages/product/AnalyticsPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { PricingPage } from './pages/PricingPage';
import { DocumentationPage } from './pages/DocumentationPage';
import { AboutPage } from './pages/AboutPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { TermsPage } from './pages/legal/TermsPage';
import { SecurityPage } from './pages/legal/SecurityPage';
import { DPAPage } from './pages/legal/DPAPage';
import { CookiePolicyPage } from './pages/legal/CookiePolicyPage';
import { AccessibilityPage } from './pages/legal/AccessibilityPage';
import { ResponsibleAIPage } from './pages/legal/ResponsibleAIPage';
import { DashboardPage } from './pages/app/DashboardPage';
import { ClientManagementPage } from './pages/app/ClientManagementPage';
import { PayrollSettingsPage } from './pages/app/PayrollSettingsPage';
import { AdminSettingsPage } from './pages/app/AdminSettingsPage';
import { UserManagementPage } from './pages/app/UserManagementPage';

function App() {
  return (
    <Routes>
      {/* Hidden internal web-app (not linked from public navigation) */}
      <Route element={<AppShellLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/client-management" element={<ClientManagementPage />} />
        <Route path="/payroll-settings" element={<PayrollSettingsPage />} />
        <Route path="/admin-settings" element={<AdminSettingsPage />} />
        <Route path="/user-management" element={<UserManagementPage />} />
      </Route>

      <Route path="/" element={<MarketingLayout />}>
        <Route index element={<HomePage />} />
        
        {/* Product Routes */}
        <Route path="product" element={<ProductOverviewPage />} />
        <Route path="product/core-hr" element={<CoreHRPage />} />
        <Route path="product/onboarding" element={<OnboardingPage />} />
        <Route path="product/attendance-leave" element={<AttendanceLeavePage />} />
        <Route path="product/payroll" element={<PayrollPage />} />
        <Route path="product/performance" element={<PerformancePage />} />
        <Route path="product/talent-management" element={<TalentManagementPage />} />
        <Route path="product/recruitment" element={<RecruitmentPage />} />
        <Route path="product/learning" element={<LearningPage />} />
        <Route path="product/employee-self-service" element={<ESSPage />} />
        <Route path="product/ai-assistant" element={<AIAssistantPage />} />
        <Route path="product/analytics" element={<AnalyticsPage />} />
        
        {/* Solutions */}
        <Route path="solutions" element={<SolutionsPage />} />
        
        {/* Pricing */}
        <Route path="pricing" element={<PricingPage />} />
        
        {/* Documentation */}
        <Route path="docs" element={<DocumentationPage />} />
        <Route path="docs/:section" element={<DocumentationPage />} />
        
        {/* About */}
        <Route path="about" element={<AboutPage />} />
        
        {/* Resources */}
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/:slug" element={<BlogPage />} />
        
        {/* Contact */}
        <Route path="contact" element={<ContactPage />} />
        <Route path="demo" element={<ContactPage />} />
        
        {/* Legal */}
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="dpa" element={<DPAPage />} />
        <Route path="cookies" element={<CookiePolicyPage />} />
        <Route path="accessibility" element={<AccessibilityPage />} />
        <Route path="responsible-ai" element={<ResponsibleAIPage />} />
      </Route>
    </Routes>
  );
}

export default App;
